import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-login-failed',
  standalone: true,
  imports: [RouterLink],
  template: `
    <div style="padding: 2rem;">
      <h1>Login failed</h1>
      <p>The Microsoft sign-in flow could not be completed.</p>
      <a routerLink="/schedule/vehicle">Try again</a>
    </div>
  `,
})
export class LoginFailedComponent {}
